const Configuracion = 
  {
    proyecto: "bancoazteca",
    version: "1.0.0",
    basedatos:"siniestrosappdev",
    mensajesplash:"",
  };
export default Configuracion;
